import type { FaireProductEntity } from "../../entity_types/product";

export const p_2pecn3redy: FaireProductEntity = {
  token: "p_2pecn3redy",
  type: "product",
  name: "LARGE Designer Scalloped Les Vines Mahjong Mats",
  brandToken: "b_yd8at4aq3v",
  brandName: "Mid Mod Design LLC",
  imageUrl:
    "https://cdn.faire.com/fastly/596e4bf9787342f01f962acc5f05ad58069fcfc68a3eed061fd3e6592e24dbf8.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/5fd913ddad1c7764f41929b849eac7e830096012a5e63ecf1d75c117500c356b.jpeg",
    "https://cdn.faire.com/fastly/31c2f5dd0d02f957856561e07c66e33053e84dca5b20c93b4ed839db72df496c.jpeg",
  ],
  priceDollars: 50,
  description:
    'This listing is for a single mahjong mat in the Les Vines Pattern with a scalloped border. The colors are extremely vibrant throughout the mat.\nComes with one soft carrying case/bag in black polyester.  \n\nMaterial Description: Polyester\nProduct Size: 31.5"x31.5"，2mm thickness.\nDesign Area: Single-sided design and single-sided printing.\nPrinting Technique: Sublimation.\nProduct Performance: Made of durable, non-slip material to keep tiles in place during play. The surface is smooth and soft, reducing noise and protecting your table.\nApplicable Scenario: Perfect for home games, club tournaments, or casual gatherings with friends and family.',
  tags: [],
  msrpDollars: 78,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:48:30.736Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
